// hooks/usePopover.ts
import {useCallback, useState} from 'react';

export interface UsePopoverProps {
	defaultOpen?: boolean
	onOpenChange?: (open: boolean) => void
}

export function usePopover({defaultOpen = false, onOpenChange}: UsePopoverProps = {}) {
	const [open, setOpen] = useState(defaultOpen);

	const handleOpenChange = useCallback((newOpen: boolean) => {
		setOpen(newOpen);
		onOpenChange?.(newOpen);
	}, [onOpenChange]);

	const show = useCallback(() => {
		setOpen(true);
	}, []);

	const hide = useCallback(() => {
		setOpen(false);
	}, []);

	const toggle = useCallback(() => {
		setOpen(prev => !prev);
	}, []);

	return {
		open,
		setOpen,
		handleOpenChange,
		show,
		hide,
		toggle,
		triggerProps: {
			open,
			onOpenChange: handleOpenChange,
		},
	};
}
